// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__K8Y7S","container":"SectionFaq_container__TTZ9V","faq__title":"SectionFaq_faq__title__NPr_G","faq__list-container":"SectionFaq_faq__list-container__XmZnH"};